import { CapacityLinkingResource } from 'app/_resources/capacity-linking.resource';
import { AuthService } from 'app/_services/auth.service';
import { UtilService } from 'app/_services/util.service';
import * as angular from 'angular';
import { PageSorting, PagingSetting } from '../custom';

class CapacityLinkingReportTableCtrl implements ng.IController {
    columnFilterOptions: { [key: string]: any } = {};
    pageSortingOptions: PageSorting = <PageSorting>{
        sortAscending: false
    };
    pagingSetting: PagingSetting = <PagingSetting>{};
    capacityLinks: DataPageDto<LinkingReportDto>;
    loadingErrMsg: string;
    loading: boolean;
    authenticatedUser: LoginResult;
    pageNumber: number = 1;
    columnFilter: string;

    constructor(
        private capacityLinkingResource: CapacityLinkingResource,
        private authService: AuthService,
        public COLUMN_FILTER: any,
        private $location: ng.ILocationService,
        private $route: ng.route.IRouteService,
        private utilService: UtilService,
        private reportsService: any,
        private $scope: ng.IScope
    ) {
        this.columnFilter = this.COLUMN_FILTER.TABLE.CAPACITY_LINKS_REPORT;
    }

    $onInit(): void {
        this.fetchOptionsFromSearchParams();

        this.authService.userLoginPromise.promise.then(
            (res) => (this.authenticatedUser = res)
        );
        if (this.columnFilterOptions.favoritesOnly !== false) {
            this.columnFilterOptions.favoritesOnly = true;
        }
        this.findReports();
    }

    findReports(): void {
        this.loading = true;
        let start = (this.pageNumber - 1) * this.pagingSetting.pageSize;

        let promise: ng.IPromise<DataPageDto<LinkingReportDto>> =
            this.capacityLinkingResource.report(
                angular.extend(
                    angular.copy(this.columnFilterOptions),
                    this.pageSortingOptions,
                    this.pagingSetting,
                    { start }
                )
            ).$promise;

        promise
            .then((res: DataPageDto<LinkingReportDto>) => {
                this.capacityLinks = res;
                this.loadingErrMsg = null;
            })
            .catch(
                (err: ng.IHttpPromiseCallbackArg<RestError>) =>
                    (this.loadingErrMsg =
                        err && err.data && err.data.message
                            ? err.data.message
                            : 'An unknown error occurred. Please, check back later.')
            )
            .finally(() => {
                this.loading = false;
            });
    }

    onPageChange(newPageNumber) {
        this.pageNumber = newPageNumber;
        this.findReports();
    }

    changeSorting(sortColumn: string): void {
        this.pageSortingOptions.sortColumn = sortColumn;
        this.pageSortingOptions.sortAscending =
            !this.pageSortingOptions.sortAscending;
        this.findReports();
    }

    private fetchOptionsFromSearchParams() {
        this.columnFilterOptions.favoritesOnly =
            this.$location.search().favoritesOnly === 'true';
        this.columnFilterOptions.entryNetworkPointName =
            this.$location.search().entryNetworkPointName;
        this.columnFilterOptions.exitNetworkPointName =
            this.$location.search().exitNetworkPointName;
        this.columnFilterOptions.tso = this.$location.search().tso;
        if (this.$location.search().runtimeFrom !== 'NONE') {
            this.columnFilterOptions.runtimeFrom =
                this.$location.search().runtimeFrom ||
                this.reportsService.getDateRange('start');
        } else {
            this.columnFilterOptions.runtimeFrom = undefined;
        }
        this.columnFilterOptions.runtimeTo = this.$location.search().runtimeTo;
        this.columnFilterOptions['quantity-min'] =
            this.$location.search()['quantity-min'] &&
            +this.$location.search()['quantity-min'];
        this.columnFilterOptions['quantity-max'] =
            this.$location.search()['quantity-max'] &&
            +this.$location.search()['quantity-max'];
        this.columnFilterOptions.capacityCategory =
            this.$location.search().capacityCategory;
        this.columnFilterOptions.bookingDateFrom =
            this.$location.search().bookingDateFrom;
        this.columnFilterOptions.bookingDateTo =
            this.$location.search().bookingDateTo;
        this.columnFilterOptions.entryDealId =
            this.$location.search().entryDealId;
        this.columnFilterOptions.exitDealId =
            this.$location.search().exitDealId;
        this.columnFilterOptions.dealId = this.$location.search().dealId;
        this.pageNumber = this.$location.search().pageNumber || 1;
        if (this.$location.search().sortAscending === 'true') {
            this.pageSortingOptions.sortAscending = true;
        }
        this.pageSortingOptions.sortColumn = this.$location.search().sortColumn;
        this.pagingSetting.amountSetting =
            this.$location.search().amountSetting;
        this.pagingSetting.costSetting = this.$location.search().costSetting;
        this.pagingSetting.pageSize = this.$location.search().pageSize || 25;
    }

    private saveOptionsToSearchParams() {
        let locationParams = angular.extend(
            angular.copy(this.columnFilterOptions),
            angular.copy(this.pageSortingOptions),
            angular.copy(this.pagingSetting),
            { pageNumber: this.pageNumber }
        );
        if (locationParams.runtimeFrom == null) {
            locationParams.runtimeFrom = 'NONE'; //save to prevent default value
        }
        this.$location.search(
            this.utilService.objectLiteralToQueryParamString(locationParams)
        );
    }
}

angular.module('app').component('pkpCapacityLinkingReportTable', {
    controller: CapacityLinkingReportTableCtrl,
    template:
        require('app/capacity-linking-reporting/capacity-linking-report-table.component.html'),
    bindings: {}
});
